import { useState, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { useNavigate } from "react-router";

import styles from "../css/Anagrams.module.css"
import WordList from "../data/Words.json"
import ScrambleList from "../data/ScrambleWords.json"
import CountDownTimer from "../components/countdownTimer.jsx"
async function CallAPI(url, body) {

    if (!body) {
        body = {
            credentials: "include"
        }
    }
    else {
        body.credentials = "include"
    }

    const response = await fetch(
        `https://anagrams.ca/api/${url}`,
        body
    );

    return response
}
export default function Anagrams() {
    const location = useLocation();
    const navigate = useNavigate();


    const [guessedWords, setGuessedWords] = useState([])
    const [scrambledArray, setScrambledArray] = useState(Array(26).fill(0))

    const [ValidWords, setValidWords] = useState([])
    const [LegalWords, setLegalWords] = useState([])

    const [wordCounts, setWordCounts] = useState(Array(10).fill(0))
    const [guess, setGuess] = useState("");
    const [LastGuess, setLastGuess] = useState("");


    const [submitted, setSubmitted] = useState(false)

    const [guessText, setGuessText] = useState("")


    const [points, setPoints] = useState(0);

    const pointsRef = useRef(0);
    const guessedWordsRef = useRef([]);

    const [votes, setVotes] = useState(0);


    useEffect(() => {
        pointsRef.current = points;
    }, [points]);

    useEffect(() => {
        guessedWordsRef.current = guessedWords;
    }, [guessedWords]);



    const pointTotals = {
        3: 100,
        4: 400,
        5: 1200,
        6: 2200,
        7: 3000,
        8: 5000,
        9: 10000
    }
    function canMakeWord(word, scrambledArray) {


        let wordArr = genScrambledArray(word);

        for (let i = 0; i < 26; i++) {
            if (wordArr[i] <= scrambledArray[i]) {
                continue
            }
            else {
                return false;
            }
        }

        return true


    }
    function getAllLegalWords(length, validWords, scrambledArray) {


        const legalWords = []
        for (const word of validWords) {
            if (canMakeWord(word, scrambledArray)) {
                legalWords.push(word);
            }

        }

        return legalWords

    }



    function hostStartGame() {

        async function StartNewGame() {
            console.log(`HOST STARTING NEW GAME`)
            const response = await CallAPI(`anagrams/${location.state.gameId}/start`, {
                method: 'POST'
            });
            const data = await response.json();

            if (data['error']) {
                return alert(data['error'])
            }
            console.log(data)
            const game = data.result;
            console.log(game)
            const settings = game.settings;
            const gameState = game.gameState;

            setGameState(gameState.state);
            setLetterCount(settings.letterCount);
            setMaxTime(settings.maxTime);
            setLetters(gameState.letters.split(''));
            setAvailableLetters(Array(settings.letterCount).fill(1));
            setPoints(0)
            setWordCounts(Array(10).fill(0));

            const scrambledArray = genScrambledArray(gameState.letters)
            setScrambledArray(scrambledArray);

            const validWords = []

            for (let i = 3; i <= settings.letterCount; i++) {
                validWords.push(...WordList[`${i}`])

            }

            setValidWords(validWords)

            const legalWords = getAllLegalWords(settings.letterCount, validWords, scrambledArray);
            const wordCountArray = Array(10).fill(0);

            for (const word of legalWords) {
                wordCountArray[word.length]++;
            }

            setWordCounts(wordCountArray);
            setLegalWords(legalWords);
        }

        StartNewGame();

    }

    function loadExistingGame() {
        async function StartNewGame() {
            console.log(`STARTING NEW GAME`)
            const response = await CallAPI(`anagrams/find/?game_id=${location.state.gameId}`, {
                method: 'GET'
            });
            const data = await response.json();

            if (data['error']) {
                return alert(data['error'])
            }

            const game = data.game;

            const settings = game.settings;
            const gameState = game.gameState

            setGameState(gameState.state);
            setLetterCount(settings.letterCount);
            setMaxTime(settings.maxTime);
            setLetters(gameState.letters.split(''));
            setAvailableLetters(Array(settings.letterCount).fill(1));
            setPoints(0)
            setWordCounts(Array(10).fill(0));

            const scrambledArray = genScrambledArray(gameState.letters)
            setScrambledArray(scrambledArray);

            const validWords = []

            for (let i = 3; i <= settings.letterCount; i++) {
                validWords.push(...WordList[`${i}`])

            }

            setValidWords(validWords)

            const legalWords = getAllLegalWords(settings.letterCount, validWords, scrambledArray);
            const wordCountArray = Array(10).fill(0);

            for (const word of legalWords) {
                wordCountArray[word.length]++;
            }

            setWordCounts(wordCountArray);
            setLegalWords(legalWords);
        }
        StartNewGame()
    }

    function genScrambledArray(word) {
        let arr = Array(26).fill(0)

        for (const letter of word) {
            const l_index = letter.toLowerCase().charCodeAt(0) - 97
            arr[l_index] += 1;
        }
        return arr
    }




    function handleChange(e) {
        const newGuess = e.target.value.toUpperCase();

        setGuess(newGuess);

        const newAvail = Array(letterCount).fill(1);

        for (const typedLetter of newGuess) {
            for (let i = 0; i < letterCount; i++) {
                if (
                    newAvail[i] === 1 &&
                    letters[i]?.toUpperCase() === typedLetter
                ) {
                    newAvail[i] = 0;
                    break;
                }
            }
        }

        setAvailableLetters(newAvail);
    }

    function handleSubmit(e) {
        e.preventDefault();

        if ((gameState != 1 && isHost) || guess.length < 3 || guess.length > letterCount || guess == '') {
            return
        }
        setSubmitted(true)
        setAvailableLetters(Array(letterCount).fill(1));
        if (checkWord(guess)) {
            if (guessedWords.includes(guess)) {
                setGuessText(`You already have guessed ${guess}!`)
                setGuess("")
                return
            }



            const guessArr = genScrambledArray(guess);

            for (let i = 0; i < 26; i++) {

                if (guessArr[i] <= scrambledArray[i]) {
                    continue;
                }
                else {
                    setGuessText(`${guess} uses invalid letters! Please try again!`);
                    setGuess("")
                    return
                }
            }





            let pointsGained = pointTotals[guess.length]
            setGuessText(`${guess}: +${pointsGained} Points!`)
            setPoints(prev => prev + pointsGained)
            setGuessedWords(prev => [...prev, guess])
            if ([...guessedWords, guess].length >= LegalWords.length) {
                setGuessText(`Successfully guessed all words!`);
                EndGame();
            }
            setGuess("")
            return
        }
        setGuessText(`${guess} is not a valid word.`);
        setGuess("")
        return



    }

    function checkWord(word) {

        return ValidWords.includes(word.toLowerCase())
    }

    function EndGame() {

        setGuessText("")

        async function end() {
            setGameState(2);
            const response = await CallAPI(`anagrams/${location.state.gameId}/end`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    username: location.state.username,
                    guessedWords: guessedWordsRef.current,
                    points: pointsRef.current
                })

            });
            const data = await response.json();
            if (data['error']) {
                return alert(data['error']);
            }
            const game = data.result;


        }
        end()
    }

    async function SetLetterCounts(e) {
        const value = Number(e.target.value);

        const response = await CallAPI(
            `anagrams/${gameId}/update`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    letterCount: value
                })
            }
        );

        setLetterCount(value);
    }

    async function updateSettings(maxPlayers, maxTime) {

        const response = await CallAPI(
            `anagrams/${gameId}/update`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    maxPlayers: maxPlayers,
                    maxTime: maxTime,
                })
            }
        );


        setMaxTime(maxTime);
        setMaxPlayers(maxPlayers);
    }

    async function voteRematch() {
        const response = await CallAPI(
            `anagrams/${gameId}/rematch`,
            {
                method: "POST"
            }
        )

        const data = await response.json();

        if (data['error']) {
            return alert(data['error'])
        }

        const votes = data.votes;

        if (data.game_id) {

            navigate(`/anagramsMultiplayer`, {
                state: {
                    gameId: data.game_id,
                    username: location.state.username,
                }
            });
        }
        else {

            setVotes(votes);

        }

    }

    const [gameId, setGameId] = useState("");
    const [gameState, setGameState] = useState(0);
    const [globalState, setGlobalState] = useState(0);
    const [letterCount, setLetterCount] = useState(6);
    const [isHost, setIsHost] = useState(false);
    const [maxTime, setMaxTime] = useState(0);
    const [maxPlayers, setMaxPlayers] = useState(2);
    const [currPlayers, setCurrPlayers] = useState(0);
    const [letters, setLetters] = useState(Array(6).fill(null));
    const [AvailableLetters, setAvailableLetters] = useState(Array(letterCount).fill(1));
    const [globalScores, setGlobalScores] = useState({});

    useEffect(() => { // Variable Startup
        async function getGameDetails() {
            console.log(location.state.gameId)
            const response = await CallAPI(`anagrams/find?game_id=${location.state.gameId}`);
            const data = await response.json();

            const game = data.game;
            const gameState = game.gameState;
            const settings = game.settings;

            setGameId(game.game_id);
            setGameState(gameState.state);
            setLetters(gameState.letters?.split("") || []);
            setLetterCount(settings.letterCount)
            setGuess("")
            setLastGuess("")
            setPoints(0)
            setVotes(0)
            pointsRef.current = 0;
            guessedWordsRef.current = [];
            setGuessedWords([])
            setAvailableLetters(useState(Array(settings.letterCount).fill(1)))
            console.log(`Setting Global State to ${gameState.state}`)
            setGlobalState(gameState.state);
            setMaxTime(settings.maxTime)
            const isHost = game.host == location.state.username
            setIsHost(isHost);
            setCurrPlayers(game.player_count);
            

        }
        getGameDetails()
    }, [location.state.gameId])

    useEffect(() => {
        async function updateGame() {
            const response = await CallAPI(
                `anagrams/find?game_id=${location.state.gameId}`
            );

            const data = await response.json();

            const game = data.game;
            const settings = game.settings;

            setGameId(game.game_id);
            setLetterCount(settings.letterCount)
            setMaxTime(settings.maxTime)
            setMaxPlayers(settings.maxPlayers)
            setCurrPlayers(game.player_count);

            const isHost = game.host == location.state.username
            setIsHost(isHost);

            const newState = game.gameState.state
            setGlobalState(newState);

            console.log(`GameState: ${gameState}\nNewState: ${newState}`)

            console.log(game)

            if (gameState === 0 && newState === 1) {
                console.log(`Update Check1`);
                setGameState(1);
                loadExistingGame();



            }
            if (gameState === 2 && newState === 2) {
                console.log(`Update Check 2`);

                setGlobalState(2);
                setGameState(2);
                console.log(`Setting global scores`);
                console.log(game.scores);
                setGlobalScores(game.scores);

                const newGameId = game.rematch?.gameId;
                if (newGameId) {
                    navigate(`/anagramsMultiplayer`, {
                        state: {
                            gameId: newGameId,
                            username: location.state.username,
                        }
                    });



                    
                }
                else {
                    setVotes(game.rematch?.playerCount || 0);
                }

            }

            if (newState == 3) {
                console.log(`Update Check 3`);

                return navigate(`/AnagramsLobby`);
            }


        }

        updateGame();

        const interval = setInterval(updateGame, 3000);

        return () => clearInterval(interval);
    }, [location.state.gameId, gameState]);

    async function deleteGame() {
        const response = await CallAPI(
            `anagrams/${gameId}/delete`, {
            method: "POST"
        });

        const data = await response.json();

        const game = data.result;
        const newState = game.gameState.state
        setGameState(newState);

    }
    function shuffleLetters() {
        const array = [...letters];
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));

            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        setLetters(array);
    }

    return (
        <>
            <div className={styles.gameLayout}>
                <div className={styles.gameId}>
                    ID: {location.state.gameId}
                </div>
                <div className={styles.timer}>
                    {(gameState == 1) && <CountDownTimer
                        key={gameId}
                        Time={maxTime || 60}
                        OnComplete={EndGame}
                    />}
                </div>
                <div className={gameState == 0 ? styles.playerCountRight : styles.playerCountLeft} >
                    {(gameState <= 2) && <PlayerCount playerCount={currPlayers} maxPlayers={maxPlayers} />}
                </div>
                <div className={styles.settings}>
                    {(gameState == 0) && isHost &&
                        <SettingsMenu
                            playerCount={maxPlayers}
                            maxTime={maxTime}
                            update={updateSettings}
                        />}
                </div>
                <div className={styles.points}>
                    {gameState != 0 && <h2>Points: {points}</h2>}
                </div>

                <div className={styles.letterRow}>
                    {gameState == 1 && <ShuffleLetters callback={shuffleLetters} />}
                    {<PrintLetters length={letterCount} availLetters={AvailableLetters} letters={letters} />}
                </div>

                {(gameState == 0 && isHost) &&
                    <div className={styles.letterCountRow}>
                        <SetLetterCount value="3" cb={SetLetterCounts} />
                        <SetLetterCount value="4" cb={SetLetterCounts} />
                        <SetLetterCount value="5" cb={SetLetterCounts} />
                        <SetLetterCount value="6" cb={SetLetterCounts} />
                        <SetLetterCount value="7" cb={SetLetterCounts} />
                        <SetLetterCount value="8" cb={SetLetterCounts} />
                        <SetLetterCount value="9" cb={SetLetterCounts} />
                    </div>}
                <br />

                <div className={styles.buttons} style={{ "display": "flex", "gap": "1em", "paddingTop": "1em" }}>
                    {(gameState == 0) && isHost && <Start handleClick={hostStartGame} started={gameState} />}
                    {(gameState == 0 || globalState == 2) && isHost && <Delete handleClick={deleteGame} />}
                    {(gameState == 1) && <End handleClick={EndGame} />}
                </div>
                <div className={styles.pendingEnd}>
                    {(gameState == 2 && globalState != 2) && <p><b>Pending Game End...</b></p>}
                </div>
                <div>
                    {(globalState == 2) && <PrintLeaderboard globalScores={globalScores} />}

                </div>



                <br />
                <div className={styles.guess}>

                    {(gameState == 1) && <SubmissionForm guess={guess} submitted={submitted} handleSubmit={handleSubmit} handleChange={handleChange} />}
                </div>
                <div className={styles.guessText}>
                    {(gameState == 1) && <SetGuessText text={guessText} />}
                </div>
                <div className={styles.wordCountSidebar}>

                    {(gameState == 1) && <PrintWordCounts wordCounts={wordCounts} guessedWords={guessedWords} />}
                </div>
                <div className={styles.GameEnd}>
                    {(gameState == 2) && <PrintResults length={letterCount} points={points} letters={letters} validWords={ValidWords} guessedWords={guessedWords} />}
                    {(gameState == 2) && <Rematch votes={votes} callback={voteRematch} playerCount={currPlayers} />}
                </div>





            </div>
        </>
    )
}




function SetLetterCount({ value, cb }) {

    return (
        <button className={styles.LetterCountButton}
            onClick={cb}
            value={value}
        >
            {value}
        </button>
    )

}


function SetGuessText({ text }) {

    if (!text) {
        return
    }
    return (
        <p>
            {text}
        </p>
    )
}

function Letter({ value, handleClick, className }) {

    return (
        <button
            className={`${styles.letter} ${styles[className]}`}
            onClick={handleClick}>
            {value}
        </button>
    )
}

function Start({ handleClick, started }) {

    return (
        <button
            className={styles.start}
            onClick={handleClick}
        >
            {started == 1 ? "Restart" : "Start"}
        </button>
    )
}

function SubmissionForm({ guess, submitted, handleSubmit, handleChange }) {


    return (
        <>

            <form onSubmit={handleSubmit}>
                <label>
                    Enter Words Here!<br />
                    <input type="text" value={guess} onChange={handleChange} />
                </label>
            </form>

        </>
    )
}

function ScrambleSubmissionForm({ setScrambleSubmit, forcedScramble, setForcedScramble }) {

    return (
        <>
            <form onSubmit={setScrambleSubmit}>
                <label>
                    Set Scramble Here!
                    <br />
                    <input
                        type="text"
                        value={forcedScramble}
                        onChange={(e) => setForcedScramble(e.target.value)}
                    />
                </label>
            </form>
        </>

    )

}
function generateWord(length) {

    let max = ScrambleList[`${length}`].length;

    const randomNumber = Math.floor(Math.random() * max);

    return ScrambleList[`${length}`][randomNumber];

}

function scrambleWord(word) {

    const letters = word.split("");

    for (let i = letters.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));

        [letters[i], letters[j]] = [letters[j], letters[i]];
    }

    return letters;

}

function End({ handleClick }) {


    return (
        <button
            className={styles.end}
            onClick={handleClick}
        >
            End Round
        </button>
    )

}
function Delete({ handleClick }) {

    return (
        <button
            className={styles.delete}
            onClick={handleClick}
        >
            Delete Lobby
        </button>
    )


}
function PrintLetters({ length, availLetters, letters }) {
    const divs = []

    for (let i = 0; i < length; i++) {

        divs.push({
            index: i,
            value: letters[i],
            inUse: availLetters[i]
        });

    }

    return (
        <>
            {divs.map((letter) => (
                <Letter className={letter.inUse ? "unused" : "used"} key={letter.index} value={letter.value} handleClick={() => { console.log(letter.value) }} />
            ))}

        </>
    )
}



function PrintResults({ length, points, letters, validWords, guessedWords }) {
    const Words = []
    const scrambledArray = genScrambledArray(letters.join(""))


    const pointTotals = {
        3: 100,
        4: 400,
        5: 1200,
        6: 2200,
        7: 3000,
        8: 5000,
        9: 10000
    }


    for (const word of validWords) {
        if (canMakeWord(word)) {
            let points = pointTotals[word.length]
            let guessed = false;

            if (guessedWords.includes(word.toUpperCase())) {
                guessed = true
            }

            Words.push(
                {
                    length: word.length,
                    word: word,
                    points: points,
                    guessed: guessed
                }
            )
        }

    }


    Words.sort((a, b) => b.length - a.length);



    return (
        <>
            <div className={styles.EndResult}>

                <h1>Total Points: {points}</h1>
                <div className={styles.WordList}>
                    <h3>Word List</h3><hr />
                    <b> Successfully Guessed {guessedWords.length} / {Words.length} words!</b>
                    <br /> <br />
                    {(() => {
                        let lastPoints = null;

                        return Words.map((word) => {
                            const showPoints = word.points !== lastPoints;
                            lastPoints = word.points;

                            return (
                                <div key={word.word}>
                                    {showPoints && (
                                        <div className={styles.PointHeader}>
                                            <br /><b>{word.points}</b>
                                        </div>
                                    )}

                                    <div className={styles.Word}>
                                        {word.guessed ? (
                                            <b>{word.word.toUpperCase()}</b>
                                        ) : (
                                            word.word.toUpperCase()
                                        )}
                                    </div>
                                </div>
                            );
                        });
                    })()}

                </div>

            </div>

        </>
    )

    function genScrambledArray(word) {
        let arr = Array(26).fill(0)

        for (const letter of word) {
            const l_index = letter.toLowerCase().charCodeAt(0) - 97
            arr[l_index] += 1;
        }
        return arr
    }


    function canMakeWord(word) {


        let wordArr = genScrambledArray(word);

        for (let i = 0; i < 26; i++) {
            if (wordArr[i] <= scrambledArray[i]) {
                continue
            }
            else {
                return false;
            }
        }

        return true


    }


}

function PrintWordCounts({ wordCounts, guessedWords }) {
    return (
        <div className={styles.WordCountPanel}>
            <h3>Words Found</h3>

            {wordCounts.map((count, index) => {
                if (index < 3 || count === 0) return null;

                const guessed =
                    guessedWords.filter(
                        str => str.length === index
                    ).length;

                return (
                    <div
                        className={styles.WordCountRow}
                        key={index}
                    >
                        <span>{index}-Letter</span>
                        <span>{guessed}/{count}</span>
                    </div>
                );
            })}
        </div>
    );
}

function PrintLeaderboard({ globalScores }) {


    const playerList = Object.keys(globalScores).sort((a, b) => globalScores[b].points - globalScores[a].points);

    return (
        <div className={styles.leaderboard}>


            {playerList.map((player) => {

                return (
                    <div
                        className={styles.player}
                        key={player}
                    >
                        <span>{player}: </span>
                        <span>{globalScores[player].points}</span>
                    </div>
                );
            })}
        </div>
    );

}
function SettingsMenu({
    playerCount,
    maxTime,
    update
}) {
    const [players, setPlayers] = useState(playerCount);
    const [time, setTime] = useState(maxTime);

    useEffect(() => {
        setPlayers(playerCount);
        setTime(maxTime);
    }, [playerCount, maxTime]);

    function handleSubmit(e) {
        e.preventDefault();
        update(players, time);
    }

    return (
        <form className={styles.settingsForm} onSubmit={handleSubmit}>
            <h3>Game Settings</h3>

            <div className={styles.settingsGroup}>
                <label>
                    Player Count
                    <input
                        type="number"
                        min="1"
                        placeholder={playerCount}
                        value={players}
                        onChange={(e) => setPlayers(e.target.value)}
                    />
                </label>
            </div>

            <div className={styles.settingsGroup}>
                <label>
                    Time (seconds)
                    <input
                        type="number"
                        min="10"
                        placeholder={maxTime}
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                    />

                </label>
            </div>

            <button
                className={styles.settingsSave}
                type="submit"
            >
                Save Settings
            </button>
        </form>
    );
}
function PlayerCount({ playerCount, maxPlayers }) {

    return (
        <>
            <b>Player Count</b><br />
            <b>{playerCount} / {maxPlayers}</b>
        </>
    )


}

function ShuffleLetters({ callback }) {

    return (
        <>
            <button className={styles.shuffleBtn} onClick={callback}>
                <img className={styles.shuffleImg} src="/api/images/shuffle.png" alt="shuffle" />
            </button>

        </>

    )

}

function Rematch({ votes, playerCount, callback }) {

    return (
        <>
            <button className={styles.rematchBtn} onClick={callback}>
                Vote Rematch: {votes}/{playerCount}
            </button>

        </>

    )
}
